import { render } from "./CartTableReview.vue?vue&type=template&id=64c43a04"
import script from "./CartTableReview.vue?vue&type=script&lang=js"
export * from "./CartTableReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__